import React from "react";
import {
  Card,
  CardBody,
  Typography,
  Button
} from "@material-tailwind/react";
import { ArrowLongRightIcon, ShieldCheckIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

export default function CiberCracontent() {

  

  return (
    <>
      
      <div className="w-full mx-auto inline-block md:w-3/4 md:flex-row ">

<nav
    className="w-11/12 mx-auto mt-6 mb-2 text-sm text-gray-500 lg:w-full"
    aria-label="Breadcrumb"
  >
    <Link
      to="/Servicios-Ciberseguridad"
      className="hover:text-indigo-600 transition font-medium"
    >
      Ciberseguridad
    </Link>
    <span className="mx-2">›</span>
    <span className="text-gray-800">
      Prevención — CRA
    </span>
  </nav>
  
        <div className="flex items-center gap-3 w-11/12 mx-auto mt-5 md:mt-0 lg:w-full mb-3">
  <ShieldCheckIcon className="text-indigo-500 w-10 h-10 group-hover:text-white" />

  <Typography
    variant="h3"
    className="text-black font-sanz text-left"
  >
    Prevención — CRA (Cyber Risk Assessment)
  </Typography>
</div>

        <Typography
          className="w-11/12 mx-auto md:mt-0 text-left lg:w-full font-mono text-xl"
        >Ofrecemos servicios de aseguramiento ofensivo que permiten identificar riesgos antes de que se conviertan en incidentes reales. Evaluamos tu nivel de exposición mediante pruebas de penetración, análisis de aplicaciones y ejercicios de Red Team y Purple Team, además de simulaciones de ataque controladas que revelan brechas críticas. <br/>
        <br/>A partir de estos hallazgos, desarrollamos recomendaciones claras y priorizadas para que fortalezcas tu seguridad de manera preventiva y enfocada en los riesgos que realmente importan.
        </Typography>
        <div className="flex flex-wrap justify-center gap-3 mt-10 md:justify-around">

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Pentesting
                </Typography>
                <Typography className="group-hover:text-white">
                  Evaluación de seguridad que simula ataques reales para identificar vulnerabilidades en sistemas, redes y aplicaciones.
             <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Pruebas de intrusión externas e internas
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Análisis de aplicaciones web y móviles
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Pruebas de red e infraestructura
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Evaluación de controles de seguridad
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Reportes detallados con recomendaciones
  </li>
</ul>
                </Typography>
              </CardBody>
           
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Cyber Risk Assessment
                </Typography>
                <Typography className="group-hover:text-white">
                  Identificación y evaluación sistemática de vulnerabilidades técnicas y su impacto potencial en el negocio.
             <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Escaneo de vulnerabilidades automatizado
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Análisis de configuraciones de seguridad
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Evaluación de exposición externa
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Priorización basada en riesgo
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Plan de remediación estratégico
  </li>
</ul>
                </Typography>
              </CardBody>
        
            </div>
          </Card>

 <Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Phishing Campaign
                </Typography>
                <Typography className="group-hover:text-white">
                  Simulación de campañas de phishing controladas para medir la concienciación y mejorar la resiliencia del personal.
             <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Campañas personalizadas
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Simulación de spear phishing
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Métricas de click-through
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Entrenamiento contextual inmediato
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Reportes de concienciación
  </li>
</ul>
                </Typography>
              </CardBody>
              
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Secure Code Analysis
                </Typography>
                <Typography className="group-hover:text-white">
                  Revisión exhaustiva del código fuente y aplicaciones para identificar vulnerabilidades de seguridad.
             <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> SAST (Static Application Security Testing)
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> DAST (Dynamic Application Security Testing)
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Análisis de dependencias
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Revisión de código manual
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Integración en CI/CD
  </li>
</ul>
                </Typography>
              </CardBody>
          
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  PCI Analysis
                </Typography>
                <Typography className="group-hover:text-white">
                  Evaluación de cumplimiento con el estándar PCI DSS para organizaciones que manejan datos de tarjetas de pago.
             <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Evaluación de requisitos PCI DSS
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Pruebas de penetración específicas
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Revisión de controles de acceso
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Análisis de segmentación de red
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Preparación para auditorías
  </li>
</ul>
                </Typography>
              </CardBody>
           
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Awareness & Secure Code Training
                </Typography>
                <Typography className="group-hover:text-white">
                  Programas de capacitación para desarrolladores y personal técnico en prácticas de codificación segura.
             <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Talleres de seguridad para desarrolladores
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Entrenamiento en OWASP Top 10
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Prácticas de codificación segura
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Revisión de código guiada
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Capacitaciones internas
  </li>
</ul>
                </Typography>
              </CardBody>
          
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  WiFi Attack Assessment
                </Typography>
                <Typography className="group-hover:text-white">
                  Evaluación de seguridad de redes inalámbricas para detectar vulnerabilidades en implementaciones WiFi.
             <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Auditoría de redes WiFi corporativas
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Pruebas de autenticación
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Evaluación de puntos de acceso
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Análisis de configuraciones
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Pruebas de rogue access points
  </li>
</ul>
                </Typography>
              </CardBody>
            
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Physical Attack Assessment
                </Typography>
                <Typography className="group-hover:text-white">
                  Evaluación de controles de seguridad física y pruebas de acceso no autorizado a instalaciones.
             <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Pruebas de acceso físico
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Evaluación de controles de entrada
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Análisis de sistemas de vigilancia
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Pruebas de tailgating
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Evaluación de políticas de acceso
  </li>
</ul>
                </Typography>
              </CardBody>
          
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  CIS Controls Hardening
                </Typography>
                <Typography className="group-hover:text-white">
                  Implementación y verificación de los controles críticos de seguridad definidos por el Center for Internet Security (CIS).
             <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Evaluación de controles CIS
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Hardening de sistemas operativos
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Configuración segura de servicios
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Automatización de hardening
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Verificación de cumplimiento
  </li>
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Solicitar este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Attack Simulation
                </Typography>
                <Typography className="group-hover:text-white">
                  Simulación de ataques avanzados (APT) para evaluar capacidades de detección y respuesta.
             <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Simulación de adversarios APT
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Pruebas de detección EDR/SIEM
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Evaluación de tiempos de respuesta
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Simulación de ransomware
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Pruebas de recuperación
  </li>
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Solicitar este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Tabletop Exercises
                </Typography>
                <Typography className="group-hover:text-white">
                  Ejercicios de simulación en escenario para entrenar equipos de respuesta a incidentes y liderazgo.
             <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Escenarios de incidentes realistas
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Ejercicios para equipos de crisis
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Validación de planes de respuesta
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Evaluación de toma de decisiones
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Mejora de comunicaciones y coordinación
  </li>
</ul>
                </Typography>
              </CardBody>
         
            </div>
          </Card>


           {/* Botón solicitar serrvicio*/}

            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
                <button>
<Link to="/Contact/#form" className="inline-block ">
                                    <Button onClick={() => { localStorage.setItem("ESP", "CIB"); localStorage.setItem("SER", "AAC") }} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                                        Solicitar este servicio
                                        <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                                    </Button>
                                </Link>
                                </button>
         
          </div>

          {/* Botón solicitar serrvicio*/}
          
        </div>
      </div>
    </>
  );
}